<h4 style="text-align: center;
font-size: 30px;">Multifamily Templates</h4>

<div style="display: flex;
flex-direction: row;
flex-wrap: nowrap;
justify-content: space-around;
width: 50%;
margin-left: 25%;">
  <button class="boxShadowButton" (click)="setTemplateStyle(1)">Create New Template</button>
</div>


<div style="margin-top: 40px;
display: flex;
flex-wrap: nowrap;
justify-content: space-evenly;">

<!-- Template side -->
<ng-template [ngIf]="templateStyle == 1 || templateStyle == 3">
  <div id="newTemplateContainer" style="border-style: solid;
  height: 700px;
  width: 100%;
  background-color: white;">

  <div id = "template-name" style="display: flex;
  flex-direction: row;
  align-content: stretch;
  align-items: center;
  margin: 10px;">


    <p style="text-align: center;
    font-size: 18px;
    font-weight: 200;
    margin-right: 10px;">Name: </p>
    <mat-form-field floatLabel="never" style="width:500px;"><input class='borderlessInput' style="width: 500px;
      font-size: 22px;
      position: relative;
      top: 4px;" matInput  placeholder="Enter template name here"  [(ngModel)]="templateName"></mat-form-field>


  </div>

  <div id = "template-name" style="display: flex;
  flex-direction: row;
  align-content: stretch;
  align-items: center;
  margin: 12px;
  position: relative;
  top: -1em;" *ngIf="templateName">



    <textarea [(ngModel)]="templateDesc" placeholder= "Enter description here (optional)" floatLabel="never" style="width:500px;" rows="3">
    </textarea>


  </div>

  <button style="color: white;
  background: #69b644;
  border: 0;
  position: relative;
  top: -20px;
  margin-left: 20px;
  height: 40px;
  border-radius: 6px;" (click)="addDialog()"> New Question </button>

  <button style="    color: rgb(35, 35, 35);
  background: #ffffff;
  border: 1px solid black;
  position: relative;
  top: -20px;
  margin-left: 20px;
  height: 40px;
  border-radius: 6px;" class="clear-button" (click)="clearTemplate()" *ngIf="templateName"> Clear Template </button>

  <button style="    color: rgb(35, 35, 35);
  background: #ffffff;
  border: 1px solid black;
  position: relative;
  top: -20px;
  margin-left: 20px;
  height: 40px;
  border-radius: 6px;" class="clear-button" (click)="backFunction()" > Back</button>

 <button style="color: rgb(35, 35, 35);
 background: #ffffff;
 border: 1px solid black;
 position: relative;
 top: -20px;
 margin-left: 20px;
 height: 40px;
 border-radius: 6px;
 float: right;
 right: 20px;" class="clear-button" *ngIf='selectedQuestionList.length > 0 && !editMode' (click)="saveTemplate()"> Save Template </button>

  <button style="color: rgb(35, 35, 35);
  background: #ffffff;
  border: 1px solid black;
  position: relative;
  top: -20px;
  margin-left: 20px;
  height: 40px;
  border-radius: 6px;
  float: right;
  right: 20px;" class="clear-button" *ngIf='selectedQuestionList.length > 0 && editMode' (click)="updateTemplate()"> Update Template </button>

  <!--
  <button style="    color: white;
  background: #69b644;
  border: 0;
  position: relative;
  top: -20px;
  margin-left: 20px;
  height: 40px;
  border-radius: 6px;"> New Question </button> -->

  <div id="question-container" style="display: flex;
  justify-content: center; height: 550px;" *ngIf="templateName">


    <div id="question-block" style="background-color: #eeeeee;
    height: 100px;
    width: 95%;
    height:80%;
    overflow-y: scroll;">


    <div *ngFor="let data of selectedQuestionList; let indexOfElement = index;" style="width: 80%;">



        <div><h4 style="margin-top:10px;
        font-weight: 700;
          font-size: 16px;
          margin-left: 10px;
          margin-bottom: 10px;">{{data.descr}}</h4></div>


        <div><h5 style="font-style: italic;
          color: grey;
          font-weight: 200;
          font-size: 16px;
          margin-bottom: 20px;
          margin-left: 10px;">{{getHumanType(data.inpt)}}</h5></div>

          <button style="background: #f87878;
          color: white;
          position: relative;
          left: 108%;
          top: -55px;
          border: 0;
          border-radius: 6px;" (click)="removeQuestion(indexOfElement)">X</button>

    </div> <!--ng foor goes on this div-->



    </div>

  </div>



    </div>


</ng-template>






<!-- Question side-->
<ng-template [ngIf]="showQuestions">
<div id="questions" style="border-style: solid;
height: 700px;
width: 100%;
background: grey;
overflow-y: scroll;" *ngIf="templateName">
  <!--<p> here are the questions</p> -->

  <mat-form-field appearance="fill" class="d-flex search-field">
    <mat-icon>search</mat-icon>
    <input matInput id = "theSearch"  (keyup)="search()" [(ngModel)]="searchTerm" name="search"
      placeholder="Search for a question..." />
  </mat-form-field>

  <div *ngFor="let question of fullQuestionArray; let indexOfElement = index;" class="question-div" style="width: 95%;
  border-radius: 10px;
  height: auto;">



    <div><h4 style="margin-top: 10px;
      font-weight: 700;
      font-size: 16px;
      margin-left: 10px;
      margin-bottom: 10px;
      color: white;
      line-height: 2em;">{{question.descr}}</h4></div>


    <div><h5 style="font-style: italic;
      color: grey;
      font-weight: 200;
      font-size: 16px;
      margin-bottom: 20px;
      margin-left: 10px;">{{getHumanType(question.inpt)}}</h5></div>

    <button style="background: #ffffff;
    color: black;
    position: relative;
    left: 80%;
    top: -55px;
    border: 0;
    border-radius: 6px;" (click)="addQuestionToTemplate(indexOfElement)">Add</button>

    <button style="background: black;
    color: #eeeeee;
    position: relative;
    left: 80%;
    top: -55px;
    border: 0;
    border-radius: 6px;
    margin-left: 5px;" (click)="editDialog(question)">Edit</button>

    <button style="background: red;
    color: #eeeeee;
    position: relative;
    left: 80%;
    top: -55px;
    border: 0;
    border-radius: 6px;
    margin-left: 5px;" (click)="delete(question)">X</button>

      <!--<button style="background: #f87878;
      color: white;
      position: relative;
      left: 108%;
      top: -55px;
      border: 0;
      border-radius: 6px;">X</button> -->

</div> <!--ng foor goes on this div-->



</div>
</ng-template>

<ng-template [ngIf]="templateStyle == 2" id="updateTemplate" >
  <div id="updateTemplateContainer" style="border-style: solid;
  height: 700px;
  width: 100%;
  background-color: white;">

  <div id = "template-name" style="display: flex;
  flex-direction: row;
  align-content: stretch;
  align-items: center;
  margin: 15px;">


    <p style="text-align: center;
    font-size: 20px;
    font-weight: 200;
    margin-right: 10px;">Search: </p>
    <mat-form-field floatLabel="never" style="width:500px;"><input class='borderlessInput' style="width: 500px;
      font-size: 22px;
      position: relative;
      top: 4px;" matInput  placeholder="Enter name here"  [(ngModel)]="templateName"></mat-form-field>


  </div>

  <!--
  <button style="color: white;
  background: #69b644;
  border: 0;
  position: relative;
  top: -20px;
  margin-left: 20px;
  height: 40px;
  border-radius: 6px;" (click)="addDialog()"> New Question </button>

  <button style="    color: rgb(35, 35, 35);
  background: #ffffff;
  border: 1px solid black;
  position: relative;
  top: -20px;
  margin-left: 20px;
  height: 40px;
  border-radius: 6px;" class="clear-button" (click)="clearTemplate()"> Clear Template </button>

-->

<!--
 <button style="color: rgb(35, 35, 35);
 background: #ffffff;
 border: 1px solid black;
 position: relative;
 top: -20px;
 margin-left: 20px;
 height: 40px;
 border-radius: 6px;
 float: right;
 right: 20px;" class="clear-button" *ngIf='selectedQuestionList.length > 0' (click)="saveTemplate()">  Template </button> -->

  <!--
  <button style="    color: white;
  background: #69b644;
  border: 0;
  position: relative;
  top: -20px;
  margin-left: 20px;
  height: 40px;
  border-radius: 6px;"> New Question </button> -->

  <div id="question-container" style="display: flex;
  justify-content: center; height: 550px;">


    <div id="question-block" style="background-color: #eeeeee;
    height: 100px;
    width: 95%;
    height:100%;
    overflow-y: scroll;">


    <div *ngFor="let data of templates; let indexOfElement = index;" style="width: 100%;" class="hoverTemplate">



        <div><h4 style="margin-top:10px;
        font-weight: 700;
          font-size: 16px;
          margin-left: 10px;
          margin-bottom: 10px;">{{data.name}}</h4></div>


        <div><h5 style="font-style: italic;
          color: grey;
          font-weight: 200;
          font-size: 16px;
          margin-bottom: 20px;
          margin-left: 10px;">{{data.description || ''}} [{{data.numfields || 'N/A'}} fields. Created {{data.creation.substring(0,10)}}]</h5></div>

            <button style="background: #ffffff;;
            color: rgb(0, 0, 0);
            position: relative;
            left: 80%;
            top: -55px;
            border: 0;
            border-radius: 6px;" (click)=copyDialog(data)><i class="fa fa-solid fa-copy"></i></button>

          <button style="background: #69b644;;
          color: white;
          position: relative;
          left: 80%;
          top: -55px;
          border: 0;
          border-radius: 6px;" (click)="editTemplate(data)"><i class="fa fa-solid fa-pencil"></i></button>

          <button style="background: #f87878;
          color: white;
          position: relative;
          left: 80%;
          top: -55px;
          border: 0;
          border-radius: 6px;"><i class="fa fa-solid fa-trash"></i></button>

    </div> <!--ng foor goes on this div-->



    </div>

  </div>



    </div>


</ng-template>


</div>
